import { useAuth } from '../../../context/AuthContext'
import ListModule from '../../module/ListModule'
import { useOutletContext } from 'react-router-dom'
import { getUserColumns } from './UserFields'
import { useEffect, useMemo, useState } from 'react'
import Loading from '../../common/Loading'
import { getObjectsWithFilter } from '../../../api/apiClientCrud'
import { toast } from 'react-toastify'
import { Box } from '@mui/material'

const ListUser = () => {
  const [roles, setRoles] = useState([])
  const { user } = useAuth()
  const userRight = useOutletContext()

  useEffect(() => {
    const loadData = async () => {
      try {
        const rolesRes = await getObjectsWithFilter('roles', { company_id: user.company_id })
        setRoles(Array.isArray(rolesRes.data?.roles) ? rolesRes.data.roles : [])
      } catch (error) {
        toast.error('Erreur lors du chargement', { autoClose: 2000 })
      }
    }

    loadData()
  }, [user.company_id])

  const columns = useMemo(() => {
    if (!roles.length) return []
    return getUserColumns({ roles })
  }, [roles])

  const options = useMemo(
    () => ({
      objectType: 'users',
      accessRight: userRight,
      actions: {
        add: true,
        edit: true,
        view: true,
        delete: {
          message: "Voulez-vous vraiment supprimer l'utilisateur"
        }
      },
      objectFilter: () => ({ company_id: user.company_id }),
      isExpand: false,
      isFilter: true,
      columns
    }),
    [userRight, user.company_id, columns]
  )

  const toolbar = useMemo(
    () => ({
      objectType: 'users',
      accessRight: userRight,
      title: 'Utilisateurs',
      actions: {
        add: true
      },
      columns: options.columns,
      isFilter: true,
      columnVisibility: true
    }),
    [userRight, options]
  )

  if (!columns.length)
    return (
      <Box
        sx={{
          display: 'flex',
          flex: 1,
          height: '100%',
          minHeight: '100px',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <Loading />
      </Box>
    )
  return <ListModule options={options} toolbar={toolbar} />
}

export default ListUser
